<!-- eslint-disable -->
<template lang="pug">
    div.generator-form
        div.generator-form__divider
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_generator_comment')")
            cs-input(v-model="selectedGame.text")
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_mode')")
            cs-multiselect(
                :multiple="false",
                :options="modes",
                :show-labels="false",
                :allow-empty="false",
                label="label"
                placeholder="",
                :value="{label: $i18n.t('trainer')[selectedGame.parameters.mode], value: selectedGame.parameters.mode}"
                @select="selectMode"
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_numOfExamples')")
            cs-select.generator-form__select(
                v-model="selectedGame.parameters.amountOfExamples",
                :options="examples",
                placeholder=""
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_positiveAnswers')")
            cs-checkbox.generator-form__checkbox(
                v-model="selectedGame.parameters.positiveAnswers",
                :disabled="positiveAnswersDisabled"
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_negativeAnswers')")
            cs-checkbox.generator-form__checkbox(
                v-model="selectedGame.parameters.negativeAnswers",
                :disabled="negativeAnswersDisabled"
            )
        form-group.generator-form__form-group(
                :label="$i18n.t('trainer.trainer_gameFormSettingDivision_mode')",
                v-if="!selectedGame.parameters.operations.multiply && selectedGame.parameters.operations.divide"
            )
            cs-multiselect.generator-form__checkbox(
                v-model="selectedGame.parameters.divMode",
                :options="divisionModes",
                :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseModeForDivision')",
                :multiple="false",
                :allow-empty="true",
                :custom-label="divisionMode",
                :show-labels='false',
            )
        div.generator-form__divider
        div.generator-form__columns
            div.generator-form__column-block
                div.generator-form__column-header(v-text="selectedGame.parameters.numbers.length === 0 ? $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier') : $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier')")
                cs-checkbox.generator-form__checkbox(
                    v-model="selectedGame.parameters.fractions.left",
                    :disabled="selectedGame.parameters.numbers.length !== 0 || !!selectedGame.parameters.divMode"
                ) {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}
                template(v-if="selectedGame.parameters.fractions.left")
                    span {{ $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints') }}
                    cs-select.generator-form__select(
                        v-model="selectedGame.parameters.fractionalPart.left",
                        :options="fractionalParts",
                        placeholder=""
                    )
                div.generator-form__column-container
                    div.generator-form__column
                        cs-checkbox(
                            v-for="(number, index) in numbers",
                            :key="index",
                            :checked="selectedGame.parameters.numbers.includes(number)",
                            @change="checkboxHandler(number)"
                            :disabled="!!selectedGame.parameters.divMode"
                        ) {{ number }}
                    div.generator-form__vertical-divider
                    div.generator-form__column
                        cs-checkbox(
                            v-for="(name, index) in digitCapacity",
                            :key="index",
                            :checked="+selectedGame.parameters.digitCapacity.left === +index",
                            @change="checkboxHandler(index, 'left')",
                            :disabled="leftDigitCapacityDisabled(index)"
                        ) {{ name }}
            div.generator-form__column-block
                div.generator-form__column-header {{ $i18n.t('trainer.trainer_gameFormSetting_operations') }}
                div.generator-form__column
                    cs-checkbox(v-model="selectedGame.parameters.operations.multiply") {{ $i18n.t('trainer.trainer_gameFormSetting_operationMultiply') }}
                    cs-checkbox(v-model="selectedGame.parameters.operations.divide") {{ $i18n.t('trainer.trainer_gameFormSetting_operationDivide') }}
            div.generator-form__column-block
                div.generator-form__column-header(v-text="selectedGame.parameters.numbers.length === 0 ? $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier') : $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier')")
                cs-checkbox.generator-form__checkbox(
                    v-model="selectedGame.parameters.fractions.right",
                    :disabled="rightFractionsDisabled"
                ) {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}
                template(v-if="selectedGame.parameters.fractions.right")
                    span {{ $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints') }}
                    cs-select.generator-form__select(
                        v-model="selectedGame.parameters.fractionalPart.right",
                        :options="+selectedGame.parameters.fractionalPart.left",
                        placeholder=""
                    )
                div.generator-form__column
                    cs-checkbox(
                        v-for="(name, index) in digitCapacity",
                        :key="index",
                        :checked="+selectedGame.parameters.digitCapacity.right === +index",
                        @change="checkboxHandler(index, 'right')",
                        :disabled="rightDigitCapacityDisabled(index)"
                    ) {{ name }}
                    cs-checkbox(
                        :disabled="selectedGame.parameters.numbers.length === 0 || selectedGame.parameters.fractions.right",
                        :checked="selectedGame.parameters.tabulatedValue",
                        @change="checkboxHandler(0, 'tabulated')"
                    ) {{ $i18n.t('trainer.trainer_gameFormSetting_tableValue') }}
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            selectedGame: Object
        },
        data() {
            return {
                examples: 100,
                numbers: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                digitCapacity: {
                    1: this.$i18n.t('common.common_gameSetting_digitCapacity1'),
                    2: this.$i18n.t('common.common_gameSetting_digitCapacity2'),
                    3: this.$i18n.t('common.common_gameSetting_digitCapacity3'),
                    4: this.$i18n.t('common.common_gameSetting_digitCapacity4'),
                    5: this.$i18n.t('common.common_gameSetting_digitCapacity5'),
                    6: this.$i18n.t('common.common_gameSetting_digitCapacity6'),
                    7: this.$i18n.t('common.common_gameSetting_digitCapacity7'),
                    8: this.$i18n.t('common.common_gameSetting_digitCapacity8')
                },
                divisionModes: ['withoutReturns', 'withOneReturn', 'withTwoReturns', 'firstDigitsAreSame', 'firstDigitsAreOne'],
                fractionalParts: 2,
                modes: [
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbacus'),
                        value: 'На счетах'
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_inMind'),
                        value: 'В уме'
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_any'),
                        value: 'Любой'
                    }
                ],
            }
        },
        mounted() {
            if (!this.selectedGame.parameters.fractions) {
                this.selectedGame.parameters.fractions = {};
            }
        },
        watch: {
            'selectedGame.parameters.operations': {
                handler(val) {
                    if (!val.divide) {
                        this.selectedGame.parameters.divMode = false;
                    }
                },
                deep: true,
            },
            'selectedGame.parameters.fractions.right': {
                handler(val) {
                    if (val && this.selectedGame.parameters.tabulatedValue) {
                        this.selectedGame.parameters.tabulatedValue = false;
                    }
                }
            },
            'selectedGame.parameters.divMode'(val) {
                val && (this.selectedGame.parameters.digitCapacity.right[0] = 2) &&
                (this.selectedGame.parameters.digitCapacity.left[0] = 3);
            },
            rightFractionsDisabled: {
                handler(val) {
                    if (val) {
                        this.selectedGame.parameters.fractions.right = false;
                    }
                }
            },
            'selectedGame.parameters.numbers': {
                handler(val) {
                    if (val && val.length) {
                        this.selectedGame.parameters.fractions.left = false;
                        if (+this.selectedGame.parameters.digitCapacity.right[0] === 1) {
                            this.selectedGame.parameters.digitCapacity.right = [];
                        }
                    }
                }
            },
            'selectedGame.parameters.fractionalPart.left': {
                handler(val) {
                    this.selectedGame.parameters.fractionalPart.right = 1;
                }
            }
        },
        computed: {
            rightFractionsDisabled() {
                return this.selectedGame.parameters
                    && (this.selectedGame.parameters.numbers.length !== 0
                        || !this.selectedGame.parameters.fractions.left);
            },
            positiveAnswersDisabled() {
                return this.selectedGame.parameters.positiveAnswers && !this.selectedGame.parameters.negativeAnswers;
            },
            negativeAnswersDisabled() {
                return this.selectedGame.parameters.negativeAnswers && !this.selectedGame.parameters.positiveAnswers;
            },
        },
        methods: {
            divisionMode(mode) {
                return this.$i18n.t(`trainer.trainer_gameFormSettingDivision_${mode}`)
            },
            checkboxHandler(number, type = null) {
                if (type) {
                    if (type === 'tabulated') {
                        this.selectedGame.parameters.digitCapacity.right = []
                        this.selectedGame.parameters.tabulatedValue = !this.selectedGame.parameters.tabulatedValue
                        return
                    }
                    if (type === 'left') {
                        this.selectedGame.parameters.numbers = []
                    }
                    this.selectedGame.parameters.tabulatedValue = false
                    this.selectedGame.parameters.digitCapacity[type] = []
                    this.selectedGame.parameters.digitCapacity[type].push(+number)
                    if (this.selectedGame.parameters.digitCapacity.left[0] < this.selectedGame.parameters.digitCapacity.right[0]) {
                        this.selectedGame.parameters.digitCapacity.right[0] = this.selectedGame.parameters.digitCapacity.left[0]
                    }
                    return
                }
                if (this.selectedGame.parameters.numbers.includes(+number)) {
                    this.selectedGame.parameters.numbers = this.selectedGame.parameters.numbers.filter(currentNumber => currentNumber !== +number)
                } else {
                    this.selectedGame.parameters.digitCapacity.left = []
                    this.selectedGame.parameters.numbers.push(+number)
                }
            },
            rightDigitCapacityDisabled(index) {
                return (
                    !!this.selectedGame.parameters.divMode ||
                    (this.selectedGame.parameters.numbers.length === 0 && this.selectedGame.parameters.digitCapacity.left[0] < index) ||
                    (+index === 1 && this.selectedGame.parameters.numbers.length !== 0)
                )
            },
            leftDigitCapacityDisabled (index) {
                return this.selectedGame.parameters.divMode && +index < 3;
            },
            selectMode(mode) {
                this.selectedGame.parameters.mode = mode.value;
            },
        }
    }
</script>

<style scoped lang="scss">
    .generator-form {
        @include stack-space($space-large);

        &__divider {
            @include stack-space($space-base);
            border-bottom: 1px solid $color-grey-300;
        }

        &__select {
            width: 100%;
        }

        &__form-group {
            @include stack-space($space-base);
        }

        &__columns {
            justify-content: space-between;
            @include make-grid(0);
        }

        &__column-block {
            @include make-col(12, 12, 0);
            @include stack-space($space-large);
        }

        &__column-container {
            @include make-grid(0);
        }

        &__column {
            @include inline-space($space-small);
        }

        &__column-header {
            @include text($font-size-16, $font-weight-bold);
            @include stack-space($space-small);
        }

        &__vertical-divider {
            border-left: 1px solid $color-grey-300;
            @include inline-space($space-small);
            display: none;
            @include media($sm) {
                display: unset;
            }
        }
    }
</style>
